import { ChartService } from "./historical-chart.service";
import { type StablecoinLatestDO } from "../data/pie-chart.data";

export class PieChartService {
  constructor(private chartService:ChartService) { }

  async loadStablecoinsLatest(): Promise<StablecoinLatestDO> {
    return await this.chartService.load('stablecoins');
  }

  async load(chartId:string) {
    const data = await this.chartService.load(chartId);
    return data;
  }

  async loadV2(chartId:string) {
    const data = await this.chartService.loadV2(chartId);
    return data;
  }
}